<template>
  <vue-final-modal
    v-slot="{ close }"
    v-bind="$attrs"
    classes="modal-container"
    :content-class="`ConfirmDialogWithEmpasis modal-content ${className}`"
    @click-outside="onClose()"
  >
    <button
      class="modal__close"
      @click="
        close();
        onClose();
      "
    >
      <span class="icon-ico_closedialog"></span>
    </button>

    <span class="modal__title">{{ title }}</span>

    <div
      class="modal__content"
      :class="{
        hasContent: content,
      }"
    >
      {{ content }}
    </div>
    <div
      class="modal__emphasis"
      :class="{
        hasEmphasis: emphasis,
      }"
    >
      {{ emphasis }}
    </div>
    <ButtonComponent
      width="98px"
      height="30px"
      color="#8d9caa"
      @click="
        close();
        onClose();
      "
    >
      OK
    </ButtonComponent>
  </vue-final-modal>
</template>

<script>
export default {
  name: "ConfirmDialogWithEmpasis",
  props: {
    title: {
      type: [String, Number],
      default: null,
    },
    content: {
      type: [String, Number],
      default: null,
    },
    emphasis: {
      type: [String, Number],
      default: null,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.ConfirmDialogWithEmpasis) {
  &.modal {
    &-content {
      position: relative;
      background-color: #fefefe;
      margin: auto;
      padding: 40px 40px 29px;
      text-align: center;
      border: 1px solid #888;
      border-radius: 5px;
      width: 450px;
      min-height: 170px;
      .modal {
        &__title {
          font-weight: bold;
          text-align: center;
          min-width: 224px;
          white-space: pre-wrap;
        }
        &__content,
        &__emphasis {
          font-size: 14px;
          text-align: center;
          white-space: pre-wrap;
        }
        &__emphasis {
          color: #c51f1f;
          font-weight: bold;
        }
        &__close {
          position: absolute;
          top: 10px;
          right: 20px;
          color: var(--color-gray);
          font-size: 20px;
        }
      }
    }
  }
}
.hasContent,
.hasEmphasis {
  margin: 20px 0;
}
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: $mobile-breakpoint) {
  ::v-deep(.ConfirmDialogWithEmpasis) {
    &.modal {
      &-content {
        width: 320px;
        min-height: 170px;
        padding: 30px 20px;
        .modal__title {
          font-size: 16px;
        }
        .modal__close {
          top: 3px;
          right: 10px;
          .icon-ico_closedialog {
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>
